var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJianchajilu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-mdl2:edit-note"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 15H6.21875L5.96875 16H2V1H3V0H4V1H6V0H7V1H9V0H10V1H12V0H13V1H14V6.0625C13.8229 6.08854 13.651 6.13281 13.4844 6.19531C13.3177 6.25781 13.1562 6.33854 13 6.4375V2H3V15ZM14.4375 7C14.6562 7 14.8594 7.03906 15.0469 7.11719C15.2344 7.19531 15.401 7.30208 15.5469 7.4375C15.6927 7.57292 15.8021 7.73698 15.875 7.92969C15.9479 8.1224 15.9896 8.32812 16 8.54688C16 8.75 15.9609 8.94792 15.8828 9.14062C15.8047 9.33333 15.6927 9.5026 15.5469 9.64844L9.94531 15.25L7 15.9844L7.73438 13.0391L13.3359 7.44531C13.487 7.29427 13.6562 7.18229 13.8438 7.10938C14.0312 7.03646 14.2292 7 14.4375 7ZM14.8359 8.94531C14.9453 8.83594 15 8.70312 15 8.54688C15 8.38542 14.9479 8.25521 14.8438 8.15625C14.7396 8.05729 14.6042 8.00521 14.4375 8C14.3646 8 14.2943 8.01042 14.2266 8.03125C14.1589 8.05208 14.099 8.09115 14.0469 8.14844L8.64062 13.5547L8.375 14.6094L9.42969 14.3438L14.8359 8.94531Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJianchajilu);
export default __webpack_public_path__ + "static/media/jianchajilu.3f7b2ac64aefebc599fc1fba2d11809a.svg";
export { ForwardRef as ReactComponent };